module.exports = __webpack_public_path__ + "img/thumb_02.58c864c8.jpg";